module.exports = __webpack_public_path__ + "img/users-right.e98fa820.svg";